import React, { FC, useContext } from 'react';
import { Box, Typography } from '@mui/material';
import { isEmpty } from 'lodash';

import { primaryBrandOrange } from 'shared/styles/muiTheme';
import classnames from 'classnames';
import { useBoundStore } from 'store';
import { LocalizationContext } from 'contexts';

export type Footnote = {
	number: number;
	text: string;
	is_renvoi: boolean;
	is_full_renvoi: boolean;
	is_parent_full_renvoi: boolean;
};

export const Footnotes: FC = () => {
  const { dictionary } = useContext(LocalizationContext);
  const { layoutTempState } = useBoundStore((state) => ({ layoutTempState: state.layoutTempState }));

  if (isEmpty(layoutTempState?.footnotes)) {
    return null;
  }

  return (
    <Box
      className="page-break"
      style={{ color: primaryBrandOrange }}>
      <Typography
        variant="h4"
        mb={3}
      >
        {dictionary.document.footnotesTitle}
      </Typography>

      <Box>
        {layoutTempState?.footnotes.map(({
																						 number,
																						 text,
																						 is_renvoi,
																						 is_full_renvoi,
																						 is_parent_full_renvoi,
																					 }: Footnote) => (
          <div
            key={number}
            style={{
              marginBottom: '8px',
              color: primaryBrandOrange,
            }}
            className={classnames({
              'is-full-renvoi': is_full_renvoi || is_parent_full_renvoi,
            })}
          >
            <span style={{ fontWeight: 'bold', marginRight: '5px', color: primaryBrandOrange }}>
              {number}.
            </span>

            <span
              style={{ color: primaryBrandOrange }}
              className={classnames({
                'is-renvoi': is_renvoi,
              })}
            >
              <span dangerouslySetInnerHTML={{ __html: text }}/>
            </span>
          </div>
        ))}
      </Box>
    </Box>
  );
};